export const TABLE_OF_CONTENTS_PANEL = 'TABLE_OF_CONTENTS_PANEL';
export const TRANSCRIPT_PANEL = 'TRANSCRIPT_PANEL';
export const STORY_PANEL = 'STORY_PANEL';
